// src/pages/ComparisonProfile/hooks/useBatchSettings.js
import { useState, useCallback } from "react";

const defaultBatchSettings = {
  transcriptList: "ENST00000316292",
  csvCheck: true,
  htmlCheck: false,
};

export const useBatchSettings = () => {
  const [batchSettings, setBatchSettings] = useState(defaultBatchSettings);

  const updateBatchSetting = useCallback((key, value) => {
    setBatchSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const resetBatchSettings = useCallback(() => {
    setBatchSettings(defaultBatchSettings);
  }, []);

  const validateBatchSettings = useCallback(() => {
    const errors = [];

    if (!batchSettings.csvCheck && !batchSettings.htmlCheck) {
      errors.push("Please select at least one output format (CSV or HTML)");
    }

    if (batchSettings.transcriptList.trim() === "") {
      errors.push(
        "Please provide at least one transcript ID for batch processing"
      );
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }, [batchSettings]);

  return {
    batchSettings,
    updateBatchSetting,
    resetBatchSettings,
    validateBatchSettings,
  };
};

export default useBatchSettings;
